import { setupTabs } from "@/components/tabs"
import { setupAccordions } from "@/components/content/Accordion"
import { setupNavbar } from "@/components/navbar"
import { setupSitewidePromo } from "@/components/sitewide_promotion"

import Emarsys from "@/helpers/emarsys"
import { setupGa4 } from "@/helpers/ga4_helper"

import { setupFooter } from "@/components/footer"

const setTurboEval = (): void => {
  // Allow some GTM scripts to re-run by ignoring `data-turbo-eval="true"`
  const scriptSelector = "script:not([data-turbo-eval='true'])"

  document.querySelectorAll(scriptSelector).forEach((script) => {
    script.setAttribute("data-turbo-eval", "false")
  })
}

const scriptMutationObserver = (callback: () => void): void => {
  new window.MutationObserver((mutations): void => {
    mutations.forEach((mutation) => {
      if ([...mutation.addedNodes].some((node) => node.nodeName === "SCRIPT")) {
        callback()
      }
    })
  }).observe(document, { subtree: true, childList: true })
}

setupFooter()
setupTabs()
setupAccordions()
setupNavbar()
setupSitewidePromo()

// This gets called on every page to ensure the cart events get sent to emarsys.
Emarsys(window.emarsysData)

setupGa4()
setTurboEval()
scriptMutationObserver(setTurboEval)
